import { Box, IconButton, Paper } from '@mui/material';
import { styled } from '@mui/system';
// import heroBackground from 'assets/Images/HelpImages/Help_Hero.png';

// Hero Section
const HeroHelp = styled(Box)(
    ({ theme }) => ({
        position: 'relative',
        width: '100%',
        padding: '60px 0 80px',
        backgroundSize: 'cover',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
            opacity: 0.9,
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '40px 0 60px'
        },
    })
);

// Hero Content
const HeroTitle = styled(Box)(
    ({ theme }) => ({
        fontSize: '48px',
        color: '#fff',
        marginBottom: '2rem',
        zIndex: '1',
        fontWeight: '700',
        [theme.breakpoints.down('md')]: {
            fontSize: '36px'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '28px'
        },
    })
);

const SearchInput = styled(Paper)(
    ({ theme }) => ({
        width: '100%',
        maxWidth: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: '1',
        borderRadius: '12px',
        '& input': {
            padding: '1rem 1.5rem',
            width: '100%',
            borderRadius: '12px',
            fontSize: '16px',
        },
        '& .MuiInputBase-root.MuiInput-root::before': {
            borderBottom: '0 !important',
        },
        '& .MuiInputBase-root.MuiInput-root::after': {
            borderBottom: '0 !important',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '300px',
            '& input': {
                padding: '0.8rem 1rem',
            }
        },
    })
);

const HelpGrid = styled(Box)(
    ({ theme }) => ({
        display: 'flex',
        gap: '2rem',
        padding: '2rem',
        [theme.breakpoints.up('md')]: {
            padding: '4rem',
        },
        [theme.breakpoints.up('xl')]: {
            padding: '6rem',
        },
    })
);

const MainContent = styled(Box)({
    flex: 1,
    minWidth: 0,
});

const ItemCard = styled(Box)(({ theme }) => ({
    borderRadius: '16px',
    padding: '2rem',
    height: '100%',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    background: theme.palette.mode === 'light' ? '#fff' : '#1a1a1a',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    border: `1px solid ${theme.palette.mode === 'light' ? '#e5e7eb' : '#2d2d2d'}`,
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
        borderColor: theme.palette.primary.main,
    },
}));

const ItemImage = styled('img')({
    width: '48px',
    height: '48px',
    objectFit: 'contain',
    marginBottom: '1rem',
});

const ItemTitle = styled(Box)(
    ({ theme }) => ({
        color: theme.palette.mode === 'light' ? '#111827' : '#fff',
        fontWeight: '600',
        fontSize: '20px',
        lineHeight: '1.4',
    })
);

const ItemDescription = styled(Box)(
    ({ theme }) => ({
        color: theme.palette.mode === 'light' ? '#4B5563' : '#9CA3AF',
        fontSize: '16px',
        lineHeight: '1.6',
    })
);

export const SidebarContainer = styled(Box)(({ theme }) => ({
    width: '300px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '16px',
    padding: '1.5rem',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    border: `1px solid ${theme.palette.mode === 'light' ? '#e5e7eb' : '#2d2d2d'}`,
    height: 'fit-content',
    position: 'sticky',
    top: '2rem',
}));

export const CollapsedSidebarContainer = styled(Box)(({ theme }) => ({
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '16px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    border: `1px solid ${theme.palette.mode === 'light' ? '#e5e7eb' : '#2d2d2d'}`,
    position: 'sticky',
    top: '2rem',
}));

export const SidebarButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
    },
}));

const ContactIcon = styled(Box)({
    position: 'fixed',
    bottom: '20px',
    right: '30px',
});

export { ContactIcon, HelpGrid, HeroHelp, HeroTitle, ItemCard, ItemDescription, ItemImage, ItemTitle, SearchInput, MainContent };

